import { Box, Button, Popover, Typography } from '@mui/material'

const DeletePopover = ({ text = 'Are you sure you want to delete this item?', anchorEl, onClose, onConfirm }) => {
  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 1, minWidth: 200 }}>
        <Typography>{text}</Typography>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
          <Button onClick={onConfirm} color="error" variant="contained" size="small">
            Confirm
          </Button>
          <Button onClick={onClose} variant="outlined" size="small">
            Cancel
          </Button>
        </Box>
      </Box>
    </Popover>
  )
}
export default DeletePopover
